export interface City {
  longitude: number;
  latitude: number;
  name: string;
}

export interface BizLine {
  from: string;
  to: string[];
}

export const cityList: Record<string, City> = {
  'hongkong': {
    name: '香港',
    longitude: 114.1694,
    latitude: 22.3193
  },
  'shanghai': {
    name: '上海',
    longitude: 121.4737,
    latitude: 31.2304
  },
  'chengdu': {
    name: '成都',
    longitude: 104.0668,
    latitude: 30.5728
  },
  'jakarta': {
    name: '雅加达',
    longitude: 106.8456,
    latitude: -6.2088
  },
  'mexicocity': {
    name: '墨西哥城',
    longitude: -99.1332,
    latitude: 19.4326
  },
  'bangkok': {
    name: '曼谷',
    longitude: 100.5018,
    latitude: 13.7563
  }
};

export const bizLines: Record<string, BizLine> = {
  'hk-lines': {
    from: 'hongkong',
    to: ['shanghai', 'chengdu', 'jakarta', 'mexicocity', 'bangkok']
  }
};